import React from "react";
import { FormattedMessage } from "react-intl";
import {
  Box,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  useColorModeValue,
  useDisclosure,
} from "@chakra-ui/react";
import { BiPencil, BiTrash } from "react-icons/bi";

import { MoreOptionsIcon } from "components/Icons";

import RenamePaymentMethodModal from "./RenamePaymentMethodModal";
import RemovePaymentMethodModal from "./RemovePaymentMethodModal";

/**
 * MoreOptionsMenu - Component to display further options for a single payment method and handle the selection of each option.
 * @param {MoreOptionsMenuProps} props
 * @param {Object} props.paymentMethod - the payment method that this component is responsible for.
 * @param {Function} props.onComplete - callback function when an action is performed successfully.
 * @returns JSX.Element
 */
const MoreOptionsMenu = ({ paymentMethod, onComplete }) => {
  const menuBtnHoverBgColor = useColorModeValue(
    "rgba(226, 232, 240, 1)",
    "rgba(255, 255, 255, 0.08)"
  );

  const removeMenuColor = useColorModeValue("#E53E3E", "#FC8181"); // red.300 and red.500 (same as error colors elsewhere)
  const { isOpen: isRenameOpen, onOpen: onRenameOpen, onClose: onRenameClose } = useDisclosure();
  const { isOpen: isRemoveOpen, onOpen: onRemoveOpen, onClose: onRemoveClose } = useDisclosure();

  return (
    <Box>
      <Menu>
        <MenuButton
          borderRadius="100"
          _hover={{
            background: menuBtnHoverBgColor,
          }}
          aria-label={`Payment Method Options for ${paymentMethod.id}`}
        >
          <MoreOptionsIcon />
        </MenuButton>
        <MenuList>
          <MenuItem icon={<BiPencil />} onClick={onRenameOpen}>
            <FormattedMessage defaultMessage="Rename" description="Option item" />
          </MenuItem>
          <MenuItem color={removeMenuColor} icon={<BiTrash />} onClick={onRemoveOpen}>
            <FormattedMessage defaultMessage="Remove" description="Option item" />
          </MenuItem>
        </MenuList>
      </Menu>
      <RenamePaymentMethodModal
        isOpen={isRenameOpen}
        onClose={onRenameClose}
        paymentMethod={paymentMethod}
        onComplete={onComplete}
      />
      <RemovePaymentMethodModal
        isOpen={isRemoveOpen}
        onClose={onRemoveClose}
        paymentMethod={paymentMethod}
        onComplete={onComplete}
      />
    </Box>
  );
};

export default MoreOptionsMenu;
